import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage ? 'bg-[#1A1A1A] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/cba2a97821e3b69b611dea227959f307/950853c41a0eb7cde6ec67e05d9bbe0d.jpeg"
              alt="Deer Point Contracting"
              className="h-40 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-6">
            <Link
              to="/"
              className="text-white hover:text-[#C5A55A] transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="text-white hover:text-[#C5A55A] transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
            >
              About
            </Link>

            {/* Services Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setServicesDropdownOpen(true)}
              onMouseLeave={() => setServicesDropdownOpen(false)}
            >
              <Link
                to="/services"
                className="text-white hover:text-[#C5A55A] transition-colors cursor-pointer whitespace-nowrap text-sm font-medium flex items-center gap-1"
              >
                Our Services
                <i className="ri-arrow-down-s-line text-sm"></i>
              </Link>

              {servicesDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-72 bg-white shadow-xl rounded-lg overflow-hidden">
                  <Link
                    to="/senior-living-healthcare-construction"
                    className="block px-6 py-3 text-[#1A1A1A] hover:bg-[#C5A55A] hover:text-white transition-colors cursor-pointer text-sm"
                  >
                    Senior Living &amp; Healthcare
                  </Link>
                </div>
              )}
            </div>

            <Link
              to="/work"
              className="text-white hover:text-[#C5A55A] transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
            >
              Our Work
            </Link>
            <Link
              to="/team"
              className="text-white hover:text-[#C5A55A] transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
            >
              Our Team
            </Link>
            <Link
              to="/careers"
              className="text-white hover:text-[#C5A55A] transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
            >
              Careers
            </Link>
            <Link
              to="/trade-partners"
              className="text-white hover:text-[#C5A55A] transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
            >
              Trade Partners
            </Link>
            <Link
              to="/contact"
              className="bg-[#C5A55A] text-[#2B2B2B] px-5 py-2 rounded-lg font-semibold hover:bg-[#B39550] transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
